import { ROLE_COLORS } from './constants';
import type { Role } from './types';

export function genId(prefix = 'id'): string {
  return `${prefix}_${Math.random().toString(36).slice(2, 10)}`;
}

export function defaultStudentPassword(rollNumber: string, firstName: string, dob: string): string {
  const yob = new Date(dob).getFullYear();
  const namePart = (firstName || '').replace(/[^a-zA-Z]/g, '').slice(0, 3);
  const cap = namePart.charAt(0).toUpperCase() + namePart.slice(1).toLowerCase();
  return `${rollNumber}${cap}${yob}`;
}

export function formatDate(iso?: string): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (isNaN(d.getTime())) return iso;
  return d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
}

export function formatDateTime(iso?: string): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (isNaN(d.getTime())) return iso;
  return d.toLocaleString('en-IN', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
}

export function formatINR(amount: number): string {
  return new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 }).format(amount);
}

export function roleColor(role: Role): string {
  return ROLE_COLORS[role];
}

export function gradeFromPercentage(percent: number): string {
  if (percent >= 90) return 'A+';
  if (percent >= 80) return 'A';
  if (percent >= 70) return 'B+';
  if (percent >= 60) return 'B';
  if (percent >= 50) return 'C';
  if (percent >= 40) return 'D';
  return 'F';
}

export function initials(name: string): string {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .map((s) => s[0]?.toUpperCase())
    .slice(0, 2)
    .join('');
}

export function todayISO(): string {
  return new Date().toISOString().slice(0, 10);
}
